<template>
	<div>
		<v-container>
			<v-row>
				<v-col md="5">
					<div>
						<!-- <h3 class="title mb-3">Capture Feed</h3> -->
					</div>
					<!-- <div class="d-flex align-center">
						<v-spacer></v-spacer>
						<div>
							<v-icon color="primary" small left>mdi-record-circle</v-icon>
							<span class="body-1">Recording</span>
						</div>
					</div> -->
					<v-card dark>
						<!-- <v-img @load="" @error="" height="450" width="100%" cover src="">
							<div class="ma-3">
								<strong class="overline">
									Footage 01
								</strong>
							</div>
						</v-img> -->
						<!-- {{ items[selectedIndex].vidSrc }} -->
						<h5 class="text-center body-1 grey--text text--lighten-3 py-4">
							Playing <strong class="white--text">{{ items[selectedIndex].title }}</strong>
						</h5>
						<video ref="vid01" loop controls width="100%" height="400px">
							<source :src="selectedVidSrc()" type="video/mp4">
						</video>
					</v-card>
					<v-list class="scrollable-list my-4" two-line>
						<v-list-item :disabled="loadingSearchResponse" v-for="(item, index) in items" :key="index"
							:class="{ 'primary': selectedIndex === index }" @click="selectItem(index)">
							<!-- Icons -->
							<v-list-item-action>
								<v-icon>{{ selectedIndex == index ? 'mdi-play-pause' : 'mdi-play' }}</v-icon>
							</v-list-item-action>

							<!-- Thumbnail -->
							<v-list-item-avatar tile size="60">
								<v-img :src="item.thumbnail"></v-img>
							</v-list-item-avatar>

							<!-- Title and Subtitle -->
							<v-list-item-content class="pl-4">
								<v-list-item-title>{{ item.title }}</v-list-item-title>
								<v-list-item-subtitle>{{ item.location }} | {{ item.timestamp }}</v-list-item-subtitle>
							</v-list-item-content>

							<v-list-item-action>
								<v-list-item-action-text v-text="item.captureTime"></v-list-item-action-text>
							</v-list-item-action>
						</v-list-item>
					</v-list>

					<!-- <v-alert width="400" class="font-weight-bold" style="margin-top: 160px;" type="error" dismissible
                        transition="fade-transition" v-model="waitForCaptioning">
                        Alert! Intrusion detected
                    </v-alert> -->

				</v-col>
				<v-col cols="7">
					<div>
						<v-row no-gutters>
							<v-col md="12">
								<v-row no-gutters>
									<v-col md="12">
										<v-card class="ma-3 pb-5 pt-4 mt-0" outlined>
											<v-card-text>
												<h4
													class="display-1 d-flex align-center justify-center primary--text pb-4">
													<!-- <v-icon x-large color="primary" left>
														mdi-information-variant-circle-outline
													</v-icon> -->
													<span>Get Video Intel</span>
												</h4>
												<!-- <h3>Capture 1: RBS_station_2_sample</h3> -->
												<div class="d-flex align-center justify-center my-4">
													<span class="body-1 mb-2 mr-2">Suggested: </span>
													<v-chip v-if="!videoSearchText" class="mr-2 mb-2"
														@click="videoSearchText = item" :key="item"
														v-for="item in searchSuggestions">
														{{ item }}
													</v-chip>
												</div>
												<div>
													<v-select label="VLM Model" outlined hide-details :items="['Llava']" value="Llava" />
												</div>
												<v-textarea hide-details class="mt-4" outlined label="Ask any Question"
													v-model="videoSearchText" rows="4"></v-textarea>
												<v-btn :disabled="!videoSearchText" :loading="loadingSearchResponse"
													class="mt-3" color="primary" @click="submitVideoSearch">
													<v-icon small left>mdi-auto-fix</v-icon>
													START
													ANALYSIS</v-btn>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>
							</v-col>
							<v-col md="12">
								<v-card class="ma-3 pt-4" outlined>
									<v-card-text>
										<v-skeleton-loader v-if="loadingSearchResponse" class="mt-3" height="150px"
											type="article">
										</v-skeleton-loader>
										<h3 class="overline text-center">Previously Asked</h3>
										<v-card v-for="(entry, index) in conversations" :key="index">

											<v-divider v-if="index > 0" class="my-3"></v-divider>

											<v-card-title>
												{{ entry.prompt }}
											</v-card-title>
											<v-card-text class="d-flex">
												<div>
													<v-img class="mr-5 rounded" width="200"
														:src="entry.data.thumbnail"></v-img>
												</div>
												<div>
													<p class="body-1">
														{{ entry.response }}
													</p>
													<p class="body-2 mt-2 white--text">
														File: <strong>{{ entry.data.title }}</strong> | Dated:
														<strong>{{ entry.data.timestamp }}</strong>
													</p>
													<v-btn outlined color="primary" small>MORE DETAILS</v-btn>
												</div>
											</v-card-text>
										</v-card>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>
					</div>
				</v-col>
				<v-col md="12">
					<div class="mx-3">
						<!-- <h3 class="title">Actions</h3>
            <div>
              <v-switch v-model="isMicActive" inset label="Mic On"></v-switch>
              <v-btn @click="imageDialogOpen = true" :disabled="!isMicActive">START BROADCAST</v-btn>
              <v-btn @click="clearlogs()">Clear Logs</v-btn>
            </div> -->
					</div>
				</v-col>
			</v-row>
		</v-container>


		<!-- <v-container>
			<v-row>
				<v-col cols="12">
					<span class="overline">RECORDS FOR</span>
					<h2 class="display-1">21st Jan, 2024 </h2>
				</v-col>
				<v-col cols="12">
					<v-row no-gutters>
						<v-col cols="6">
							<v-card v-for="i in 6" :key="`test-${i}`">
								<v-img>
									Hello
								</v-img>
								<v-card-title>
									// Here there will be image and brief of what actions was taken
								</v-card-title>
							</v-card>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-container> -->
	</div>
</template>

<script>
import axios from 'axios'
import { checkInferenceResult } from "./../api/InferencesTest"
import { sendModelQuery } from "./../api/ModelsTest"
import { values } from 'lodash';

export default {
	data() {
		return {
			items: [
				{ title: "REC_2024_10_21_QZK", location: "Sector 915", timestamp: "Sat, 21 Dec, 2024", vidSrc: require("./../assets/jungle_1_TA.mp4"), thumbnail: require('./../assets/jungle_1_TA.png'), serverFileName: "jungle_1_TA", captureTime: "14 Secs" },
				{ title: "REC_2024_10_23_XKF", location: "Sector 916", timestamp: "Wed, 21 Dec, 2024", vidSrc: require("./../assets/jungle_2_TA.mp4"), thumbnail: require('./../assets/jungle_2_TA.png'), serverFileName: "jungle_2_TA", captureTime: "41 Secs" },
				{ title: "REC_2024_10_26_PSG", location: "Sector 918", timestamp: "Sun, 23 Dec, 2024", vidSrc: require("./../assets/violence2.mp4"), thumbnail: require('./../assets/violence2.png'), serverFileName: "violence2", captureTime: "27 Secs" },
				{ title: "REC_2024_10_26_PSG", location: "Sector 918", timestamp: "Sun, 23 Dec, 2024", vidSrc: require("./../assets/violence1.mp4"), thumbnail: require('./../assets/violence1.png'), serverFileName: "violence1", captureTime: "20 Secs" },
				{ title: "REC_2024_10_26_PSG", location: "Sector 918", timestamp: "Sun, 23 Dec, 2024", vidSrc: require("./../assets/coal_video.mp4"), thumbnail: require('./../assets/coal_video.png'), serverFileName: "coal_video", captureTime: "40 Secs" },
			],
			conversations: [],
			selectedIndex: 0,
			videoSearchText: "",
			loadingSearchResponse: false,
			searchSuggestions: ['Describe the video in detail', 'What are the people doing?', 'Describe violence in the video']
		};
	},
	methods: {
		async submitVideoSearch() {

			try {
				this.loadingSearchResponse = true
				const res = await sendModelQuery({
					text: this.videoSearchText,
					filename: this.items[this.selectedIndex].serverFileName
				})
				
			} catch (error) {
				console.log(error)
				this.loadingSearchResponse = false			
			}
		},
		selectItem(index) {
			if (this.selectedIndex == index) {
				this.$refs.vid01.pause()
				return
			}

			this.selectedIndex = index;
			this.$nextTick(() => {
				this.$refs.vid01.load();
				this.$refs.vid01.play()
			})
		},
		selectedVidSrc() {
			return this.items[this.selectedIndex].vidSrc
		},
		handleInferenceResult(data) {
			if(!data.text || !this.videoSearchText) return
			this.$setSnackbar("Response received successfully");
			this.currentResponse = data.text[0].split(' ASSISTANT: ')[1]
			this.conversations.unshift({
				prompt: this.videoSearchText,
				response: this.currentResponse,
				data: { ...this.items[this.selectedIndex] }
			})			
			this.loadingSearchResponse = false				
			this.videoSearchText = ""			
		}
	},
	created() {
		checkInferenceResult(this.handleInferenceResult)
	}
};
</script>

<style>
.scrollable-list {
	max-height: 300px;
	overflow-y: auto;
	overflow-x: hidden;
}
</style>